import React from 'react';
import { Box } from '@mui/material';

// Carte de quiz : le décor (/cards/quiz-fond.webp, généré à part) est une image, et tout ce qui
// doit changer (numéro, question, image du mot, réponses) est du vrai texte / HTML posé par-dessus,
// dans les emplacements vides du décor. Ainsi la carte se traduit dans les 4 langues et garde
// les caractères duala (ɛ, ɔ, tons) que les générateurs d'images écrivent mal.
// Les positions sont en pourcentages de l'image (1122 × 1402) : la carte se met à l'échelle.
const SLOTS = {
  number: { left: 3.1, top: 2.1, width: 15.2, height: 12.5 },
  question: { left: 20, top: 6.1, width: 70.4, height: 10.7 },
  picture: { left: 21.8, top: 20.3, width: 57, height: 54.6 },
  answers: [
    { left: 3.1, top: 78.1, width: 31.2, height: 13.2 },
    { left: 36.1, top: 78.1, width: 28.1, height: 13.2 },
    { left: 66, top: 78.1, width: 31.2, height: 13.2 },
  ],
};
const ANSWER_COLORS = ['#f97316', '#fcc80c', '#06b6d4'];

const pos = (s) => ({ position: 'absolute', left: `${s.left}%`, top: `${s.top}%`, width: `${s.width}%`, height: `${s.height}%` });

/**
 * number    : numéro de la question (médaillon)
 * question  : texte de la question
 * image     : URL de l'image du mot (cadre central) ; sinon `children`
 * answers   : 3 textes de réponse
 * selected / correct : index choisi / index correct (null tant qu'on n'a pas répondu)
 * onAnswer  : (index) => void
 */
function QuizCard({ number, question, image, children, answers = [], selected = null, correct = null, onAnswer }) {
  const answered = selected !== null;
  return (
    <Box sx={{ width: '100%', maxWidth: 520, mx: 'auto', containerType: 'inline-size' }}>
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          aspectRatio: '1122 / 1402',
          backgroundImage: 'url(/cards/quiz-fond.webp)',
          backgroundSize: 'cover',
          borderRadius: 3,
          overflow: 'hidden',
          boxShadow: 3,
        }}
      >
        <Box sx={{ ...pos(SLOTS.number), display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 900, fontSize: '9cqw', color: '#c2410c' }}>
          {number}
        </Box>
        <Box sx={{ ...pos(SLOTS.question), display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center', px: '2cqw', fontWeight: 800, fontSize: '4.4cqw', lineHeight: 1.15, color: '#1f2937' }}>
          {question}
        </Box>
        <Box sx={{ ...pos(SLOTS.picture), display: 'flex', alignItems: 'center', justifyContent: 'center', p: '2cqw', boxSizing: 'border-box' }}>
          {image ? <Box component="img" src={image} alt="" sx={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain', borderRadius: 2 }} /> : children}
        </Box>
        {SLOTS.answers.map((slot, i) => {
          const isCorrect = answered && i === correct;
          const isWrong = answered && i === selected && i !== correct;
          return (
            <Box
              key={i}
              component="button"
              type="button"
              disabled={answered || !answers[i]}
              onClick={() => onAnswer && onAnswer(i)}
              sx={{
                ...pos(slot),
                border: 'none',
                borderRadius: '2.6cqw',
                cursor: answered ? 'default' : 'pointer',
                bgcolor: isCorrect ? '#22c55e' : isWrong ? '#b91c1c' : ANSWER_COLORS[i],
                color: isWrong ? '#fff' : '#1f2937',
                fontWeight: 800,
                fontSize: '4.2cqw',
                lineHeight: 1.1,
                px: '1.5cqw',
                opacity: answered && !isCorrect && !isWrong ? 0.55 : 1,
                outline: '0.8cqw solid #fff8e8',
                '&:focus-visible': { outline: '1cqw solid #1f2937' },
                transition: 'transform 120ms, opacity 150ms',
                '&:active:not(:disabled)': { transform: 'scale(0.97)' },
              }}
            >
              {answers[i]}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}

export default QuizCard;
